import { render, staticRenderFns } from "./ActionShippingPrice.vue?vue&type=template&id=6e4a0e7b&scoped=true"
import script from "./ActionShippingPrice.vue?vue&type=script&lang=js"
export * from "./ActionShippingPrice.vue?vue&type=script&lang=js"
import style0 from "./ActionShippingPrice.vue?vue&type=style&index=0&id=6e4a0e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a0e7b",
  null
  
)

export default component.exports